// 1. Import the utilities
export const breakpoints = {
  sm: '320px',
  md: '768px',
  lg: '960px',
  xl: '1200px',
  xxl: '2000px',
};
